// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Dnm6","title":"_1I1If","content":"yF_VP","button":"_2u7Us","or":"_1itpZ","img-view":"_10Q6u"};